module.exports = "<svg version=\"1.1\" baseProfile=\"tiny\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 210 210\" xml:space=\"preserve\"><rect x=\"70\" y=\"87.5\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -43.4924 105.0001)\" fill=\"#FFFFFF\" width=\"70.1\" height=\"35.1\"></rect></svg>"


//////////////////
// WEBPACK FOOTER
// /Users/jeroenbraspenning/Documents/02.PROCESS/CultuurEindhoven/cultuurprijs_website_2018/Development/eindhoven-cultuurprijs/~/svg-inline-loader!./assets/img/content/wallpaper_shape-1.svg
// module id = 34
// module chunks = 0